import { supporterQuery } from "@/api/supporter";
import { queryClient } from "@/api/utils";
import { seo } from "@/utils/seo";
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/supporters/$supporterId")({
  component: lazyRouteComponent(() => import("./+SupporterLayout")),
  beforeLoad: () => ({
    breadcrumb: "Edit Supporter",
  }),
  head: async ({ params }) => {
    const supporter = await queryClient.ensureQueryData(supporterQuery(params.supporterId));
    return {
      meta: seo({ title: supporter.name }),
    };
  },
});
